import React, { useEffect, useState, useContext } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire, faTrophy } from '@fortawesome/free-solid-svg-icons';
import BookingService from './bookings/BookingService';
import AppContext from 'context/Context';
const CurrentStreakCard = ({ data }) => {
  const [stats, setStats] = useState({
    thisWeek: 0,
    thisMonth: 0,
    bestStreak: 0,
    currentStreak: 0
  });
    const {
      config: { isDark }
    } = useContext(AppContext);
  useEffect(() => {
    BookingService.retrieveAllBookingsByUser()
      .then(data => {
        const updatedStats = {
          thisYear: data.filter(booking => {
            const bookingDate = new Date(booking.date);
            return bookingDate.getFullYear() === new Date().getFullYear();
          }).length,
          thisMonth: data.filter(booking => {
            const bookingDate = new Date(booking.date);
            return (
              bookingDate.getFullYear() === new Date().getFullYear() &&
              bookingDate.getMonth() === new Date().getMonth()
            );
          }).length,
          thisWeek: data.filter(booking => {
            const bookingDate = new Date(booking.date);
            const currentDate = new Date();
            const firstDayOfWeek = new Date(
              currentDate.setDate(currentDate.getDate() - currentDate.getDay())
            );
            const lastDayOfWeek = new Date(
              currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6)
            );
            return bookingDate >= firstDayOfWeek && bookingDate <= lastDayOfWeek;
          }).length,
          currentStreak: (() => {
            let streak = 0;
            const today = new Date();
            for (let i = 0; i < 7; i++) {
              const dateToCheck = new Date(today);
              dateToCheck.setDate(today.getDate() - i);
              const dateString = dateToCheck.toISOString().split('T')[0];
              if (data.some(booking => booking.date === dateString)) {
                streak++;
              } else {
                break;
              }
            }
            return streak;
          })(),
          bestStreak: (() => {
            let bestStreak = 0;
            let currentStreak = 0;
            const sortedBookings = data
              .map(booking => new Date(booking.date))
              .sort((a, b) => a - b);
            for (let i = 0; i < sortedBookings.length; i++) {
              if (
                i > 0 &&
                (sortedBookings[i] - sortedBookings[i - 1]) / (1000 * 60 * 60 * 24) ===
                  1
              ) {
                currentStreak++;
              } else {
                currentStreak = 1;
              }
              if (currentStreak > bestStreak) {
                bestStreak = currentStreak;
              }
            }
            return bestStreak;
          })()  
        };
        setStats(updatedStats);
      })
      .catch(error => console.log(error));  


  }, []);
  return (
    <Card
      className="h-100 border-0 shadow-sm isDark"

    >
      <Card.Body>
        <div className="text-center mb-4">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-gradient mb-3"
            style={isDark ? {
              width: '80px',
              height: '80px',
              background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)'
            } : {
              width: '80px',
              height: '80px',
              background: '#F7931E 100%'
            }}
          >
            <FontAwesomeIcon icon={faFire} size="2x" className="text-white" />
          </div>
          <h2 className="fw-bold mb-0 display-4">{stats.currentStreak}</h2>
          <p className=" mb-0">Days Streak</p>
        </div>
        { stats.thisWeek > 2 && (
          <div className="bg-dark-light rounded p-3 mb-3" style={isDark ? { backgroundColor: 'rgba(255,255,255,0.05)' } : { backgroundColor: 'rgba(0,0,0 ,0.05)' }}>
            <p className="text-white-75 mb-0 text-center">
              <strong>Amazing!</strong> You've trained {stats.thisWeek} times this week. Keep the momentum going! 💪
            </p>
          </div>
        )}

        <Row className="text-center g-3">
          <Col xs={6}>
            <div className="p-2 rounded" style={isDark ? { backgroundColor: 'rgba(255,255,255,0.05)' } : { backgroundColor: 'rgba(0,0,0 ,0.05)' }}>
              <div className="fs-4 fw-bold text-warning">
                <FontAwesomeIcon icon={faTrophy} className="me-1" />
                {stats.bestStreak}
              </div>
              <small>Best Streak</small>
            </div>
          </Col>
          <Col xs={6}>
            <div className="p-2 rounded" style={isDark ? { backgroundColor: 'rgba(255,255,255,0.05)' } : { backgroundColor: 'rgba(0,0,0 ,0.05)' }}>
              <div className="fs-4 fw-bold text-success">{stats.thisMonth}</div>
              <small>This Month</small>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CurrentStreakCard;
